import { TYPES } from '@model/utils/types';
import { Type } from './Type';

export class Float extends Type {
    static getDefault() {
        return 0.0;
    }

    static toValue(value) {
        if (!value) {
            return Float.getDefault();
        }

        return parseFloat(value);
    }
}

Float[TYPES.TYPE] = 'float';
